import { useTranslation } from '@/lib/i18n';

export default function LanguageToggle() {
    const { language, setLanguage } = useTranslation();

    return (
        <div className="flex bg-slate-100 dark:bg-slate-800 rounded-lg p-1 shadow-inner">
            <button
                onClick={() => setLanguage('no')}
                className={`px-3 py-1 rounded-md text-[10px] font-bold transition-all ${language === 'no'
                    ? 'bg-white dark:bg-slate-700 shadow-sm text-slate-900 dark:text-white'
                    : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'
                    }`}
            >
                NO
            </button>
            <button
                onClick={() => setLanguage('en')}
                className={`px-3 py-1 rounded-md text-[10px] font-bold transition-all ${language === 'en'
                    ? 'bg-white dark:bg-slate-700 shadow-sm text-slate-900 dark:text-white'
                    : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'
                    }`}
            >
                EN
            </button>
        </div>
    );
}
